// Service for the Attendance Dashboard "Mi equipo" — "Resumen del mes" "Ausencias"
// card (ASIS-5411 / REXASIS-010).
// GET /attendance/my-team/monthly-summary/absence-summary?cutoffCompanyId=1&monthlyCutId=1 —
// both query params are required: the company and monthly cutoff selected in the
// "Resumen del mes" filters panel (ASIS-5414).

import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared';
import { buildQueryString } from '@/api/shared';

import type {
  LC_GetMyTeamMonthlyAbsenceSummaryOut,
  GetMyTeamMonthlyAbsenceSummaryParams,
  MyTeamMonthlyAbsenceSummary,
} from '../types/myTeamMonthlyAbsenceSummary.types';
import { mapMyTeamMonthlyAbsenceSummary } from '../mappers/myTeamMonthlyAbsenceSummary.mapper';


export class MyTeamMonthlyAbsenceSummaryService {
  async getSummary(
    params: GetMyTeamMonthlyAbsenceSummaryParams,
    signal?: AbortSignal,
  ): Promise<ApiResponse<MyTeamMonthlyAbsenceSummary>> {
    const query = buildQueryString({
      cutoffCompanyId: params.cutoffCompanyId,
      monthlyCutId: params.monthlyCutId,
    });
    const { ATTENDANCE_MY_TEAM_MONTHLY_SUMMARY_ABSENCE_SUMMARY } = API_CONFIG.ENDPOINTS;
    const endpoint = `${ATTENDANCE_MY_TEAM_MONTHLY_SUMMARY_ABSENCE_SUMMARY}${query}`;
    const response = await apiClient.get<LC_GetMyTeamMonthlyAbsenceSummaryOut>(
      endpoint, { signal },
    );

    if (!response.success || !response.data) {
      return { ...response, data: null };
    }

    return { ...response, data: mapMyTeamMonthlyAbsenceSummary(response.data) };
  }
}

export const myTeamMonthlyAbsenceSummaryService = new MyTeamMonthlyAbsenceSummaryService();
